export const convertNumberGen = (valor) => {
    if (Number(valor)) {
      return Number(valor);
    }
    return valor;
  };